export const GeneralLedgerNumberFragment = gql`
  fragment GeneralLedgerNumberFragment on GeneralLedgerNumber {
    id
    glNumber
    glFund
    glAccount
    description
    type
  }
`
